export const FORM_CHANGE_VALUE = "FORM_CHANGE_VALUE";
export const FORM_LOAD_DATA = "FORM_LOAD_DATA";
export const FORM_LOAD_BLANK = "FORM_LOAD_BLANK";
export const FORM_LOAD_DATA_ERROR = 'FORM_LOAD_DATA_ERROR'